import TableStore from './table';

const comsWeaTableStore = new TableStore();

export default {
  comsWeaTableStore,
};



// WEBPACK FOOTER //
// ./comMobx/wea-table-new/stores/index.js